import { handleActions } from 'redux-actions';

const initialState = {
    data: [],
    links: {},
    meta: {},
    page: 1,
    limit: 10,
    sort: '',
    sortBy: '',
    searchQuery: '',
    status: '',
    retainer: true,
    archived: false,
    fetching: true,
    error: false,
}

export default handleActions({

    FETCH_CUSTOMERS: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: false,
        }
    },

    FETCH_CUSTOMERS_SUCCESS: (state, action) => {
        return {
            ...state,
            fetching: false,
            data: action.customers.data,
            links: action.customers.links,
            meta: action.customers.meta,
            page: action.customers.meta.current_page,
            limit: action.customers.meta.per_page,
            ...action.params
        }
    },

    FETCH_CUSTOMERS_FAIL: (state, action) => {
        return {
            ...state,
            fetching: false,
            error: true
        }
    },

    RESET_CUSTOMERS: (state, action) => {
        return initialState;
    }

}, initialState)